import { Trophy, Star, Award, Sparkles, Flame, Crown, Target, Rocket } from "lucide-react";

/** Badge catalog: keep synced with backend compute_badges (server.py) */
export const BADGE_CATALOG = {
    first_step: { name: "أولى الخطوات", color: "#0EA5E9", icon: Rocket, hint: "أنهيتِ أول اختبار" },
    persistent: { name: "المثابرة", color: "#059669", icon: Flame, hint: "3 اختبارات أو أكثر" },
    top_student: { name: "المتميّزة", color: "#F59E0B", icon: Star, hint: "5 اختبارات فوق 80%" },
    quant_hero: { name: "بطلة كمي", color: "#1B2A4E", icon: Target, hint: "متوسط الكمي ≥ 85%" },
    verbal_hero: { name: "بطلة لفظي", color: "#C8102E", icon: Award, hint: "متوسط اللفظي ≥ 85%" },
    class_leader: { name: "أولى الفصل", color: "#7C3AED", icon: Crown, hint: "المرتبة الأولى في فصلك" },
    perfect_score: { name: "الكمال", color: "#DB2777", icon: Sparkles, hint: "درجة كاملة 100%" },
    improvement: { name: "التحسّن", color: "#10B981", icon: Trophy, hint: "تحسّن ملحوظ في آخر 3" },
};

export function BadgePill({ id, size = "sm" }) {
    const b = BADGE_CATALOG[id];
    if (!b) return null;
    const Icon = b.icon;
    const sz = size === "lg" ? "px-3 py-1.5 text-sm" : "px-2 py-1 text-xs";
    const isz = size === "lg" ? 14 : 12;
    return (
        <span
            data-testid={`badge-${id}`}
            title={b.hint}
            style={{ backgroundColor: `${b.color}15`, color: b.color, borderColor: `${b.color}40` }}
            className={`inline-flex items-center gap-1.5 rounded-full border font-semibold ${sz}`}
        >
            <Icon width={isz} height={isz} />
            {b.name}
        </span>
    );
}

export function BadgeGrid({ badges = [], emptyText = "لم تحصلي على شارات بعد — استمري بالتدريب!" }) {
    if (!badges || badges.length === 0) {
        return <div className="text-sm text-slate-400 py-4 text-center">{emptyText}</div>;
    }
    return (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
            {badges.map((id) => {
                const b = BADGE_CATALOG[id];
                if (!b) return null;
                const Icon = b.icon;
                return (
                    <div
                        key={id}
                        data-testid={`badge-card-${id}`}
                        style={{ borderColor: `${b.color}40`, background: `linear-gradient(135deg, ${b.color}10, transparent)` }}
                        className="rounded-xl border p-4 flex flex-col items-center text-center gap-2 transition-transform hover:-translate-y-1"
                    >
                        <div
                            style={{ backgroundColor: b.color }}
                            className="w-12 h-12 rounded-full flex items-center justify-center text-white shadow-md"
                        >
                            <Icon width={24} height={24} />
                        </div>
                        <div className="font-bold text-sm" style={{ color: b.color }}>{b.name}</div>
                        <div className="text-xs text-slate-500">{b.hint}</div>
                    </div>
                );
            })}
        </div>
    );
}

/** Small badge dot shown next to an avatar */
export function AvatarBadge({ badgeId, size = 20 }) {
    const b = BADGE_CATALOG[badgeId];
    if (!b) return null;
    const Icon = b.icon;
    return (
        <div
            title={b.name}
            style={{ backgroundColor: b.color, width: size, height: size }}
            className="absolute -bottom-0.5 -left-0.5 rounded-full flex items-center justify-center text-white ring-2 ring-white shadow"
        >
            <Icon width={Math.floor(size * 0.6)} height={Math.floor(size * 0.6)} />
        </div>
    );
}
